export enum AuthState {
  Unknown = 'UNKNOWN',
  Authenticated = 'AUTHENTICATED',
  NotAuthenticated = 'NOT_AUTHENTICATED',
};

export interface IAuthState {
  authState: AuthState;
  busy: boolean;
}



// WEBPACK FOOTER //
// ./src/auth/model.ts